import React from "react";
import { Header } from "./styles";

const HeaderComponent = () => (
  <Header>
    <p>Pixar Characters</p>
    <p>
      <a href="https://www.cassandratang.me" target="_blank">
        Say hey
      </a>
    </p>
  </Header>
);

export default HeaderComponent;
